export default __webpack_public_path__ + "static/media/down-red-v2.29a788b3.svg";